import apiClient from '../lib/apiClient';

const notificationService = {
  list() {
    return apiClient.request('/user/notifications');
  },
  markRead(id) {
    return apiClient.request(`/user/notifications/${id}/read`, {
      method: 'PATCH'
    });
  },
  clearAll() {
    return apiClient.request('/user/notifications/clear', {
      method: 'DELETE'
    });
  }
};

export default notificationService;
